import { createContext, useContext } from "react";

export type ModalContextValue = { titleId: string; basic?: boolean };

export const ModalContext = createContext<ModalContextValue>({ titleId: "" });

export function useModalContext(): ModalContextValue {
  return useContext(ModalContext);
}
